import React from 'react';
import NavBar from './NavBar/NavBar';
import Routing from './Routing';

function App() {
  return (
    <>
      <NavBar />
      <Routing />
    </>
  );
}

export default App;
